import { useForm } from "react-hook-form";
import { removeEmptyFields, setEmptyFieldsToNull } from "@/lib/utils";
import { useIsMobile } from "@/hooks/use-mobile";
import { useEffect } from "react";
import {
  useGetGlMasterDataDropdown,
  useGetVendorListByCommunityId,
} from "@/services";
import { useSelector } from "react-redux";
import { RootState } from "@/redux/store";
import {
  APPROVED_BY,
  GL_ACCOUNT,
  PAYMENT_DATE_RANGE,
  POSTED_DATE_RANGE,
} from "../consts";
const useFilter = ({
  filterData,
  setFilterData,
  onCancel,
}: {
  filterData: any;
  setFilterData: (data: any) => void;
  onCancel: () => void;
}) => {
  const isMobile = useIsMobile();

  const form = useForm<any>({
    defaultValues: {
      [GL_ACCOUNT]: "",
      [PAYMENT_DATE_RANGE]: "",
      [POSTED_DATE_RANGE]: "",
      [APPROVED_BY]: "",
    },
  });

  const communityDetail = useSelector(
    (state: RootState) => state.currentData.communityData
  );
  const { data: glMasterListing, isLoading: isGlMasterLoading } =
    useGetGlMasterDataDropdown({
      communityId: communityDetail?.communityId as string,
      queryParams: {
        enabled: !!communityDetail?.communityId,
      },
    });

  useEffect(() => {
    if (filterData) {
      form.reset({
        [GL_ACCOUNT]: filterData?.[GL_ACCOUNT] || "",
        [PAYMENT_DATE_RANGE]: filterData?.[PAYMENT_DATE_RANGE] || "",
        [POSTED_DATE_RANGE]: filterData?.[POSTED_DATE_RANGE] || "",
        [APPROVED_BY]: filterData?.[APPROVED_BY] || "",
      });
    }
  }, [filterData]);

  const onSubmit = (data: any) => {
    let _data = removeEmptyFields(data);
    _data = setEmptyFieldsToNull(data);

    setFilterData({
      ..._data,
    });
    onCancel();
  };

  const onClear = () => {
    setFilterData(null);
    onCancel();
  };

  const { data: vendorList, isLoading: isVendorLoading } =
    useGetVendorListByCommunityId({
      communityId: communityDetail?.communityId,
      queryParams: {
        enabled: !!communityDetail?.communityId,
      },
    });

  return {
    form,
    onSubmit,
    isMobile,
    onClear,
    isVendorLoading,
    vendorList,
    isGlMasterLoading,
    glMasterListing,
  };
};

export default useFilter;
